import { render } from "./CategoriaEdit.vue?vue&type=template&id=05849bc4"
import script from "./CategoriaEdit.vue?vue&type=script&lang=js"
export * from "./CategoriaEdit.vue?vue&type=script&lang=js"
script.render = render

export default script